<template>
    <ur-modal ref="modal" size="large" title="변경 요청하기">
        <template>
            <table class="tbl_list">
                <colgroup>
                    <col style="width:167px">
                    <col style="width:auto">
                </colgroup>
                <tbody>
                    <tr>
                        <th>전화번호/채널</th>
                        <td>
                            <div class="tbl_info">
                                <!--<button type="button" :disabled="isRowAddDisabled" @click="onClickRowAdd" class="btn btn_border btn_s">추가</button>-->
                                <ur-button small :disabled="isRowAddDisabled" @click="onClickRowAdd" text="추가"/>
                            </div>
                            <!--<div style="width:100%; height:222px">
                                <ur-data-grid ref="grid" :options="options" :headers="headers" :data-source="items" @grid:data-changed="onDataChanged" />
                            </div>
                            -->
                            <ur-data-grid ref="grid" :options="options" :headers="headers" :data-source="items" @grid:data-changed="onDataChanged" />
                            <div class="box_common hbox">
                                <dl class="hbox">
                                    <dt>요청 전화번호 / 채널</dt>
                                    <dd class="txt_desc mt0">기존 전화번호 {{oldSipNumberCount}}개 / 채널 {{oldChannelsCount}}개</dd> 
                                </dl>
                                <dl class="hbox">
                                    <dt class="change">변경</dt>
                                    <dd>전화번호 {{newSipNumberCount}}개 / 채널 {{newChannelsCount}}개</dd>
                                </dl>
                            </div>
                            <p class="txt_desc type2">* 이미 변경 요청중인 건은 추가로 요청할 수 없습니다.<br>
                            <a :class="pClass">* 최소 전화번호 1개, 채널 4개(번호 당 1개 채널 필수) / 최대 전화번호 100개, 채널 100개 사용 가능합니다.</a>
                            </p>
                            <!--<a :class="pClass">* 최소 전화번호 1개, 채널 4개(번호 당 1개 채널 필수) / 최대 전화번호 100개, 채널 100개 사용 가능합니다.</a>-->
                            
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template #action>
            <ur-button text="취소" @click="close"/>
            <ur-button text="완료" @click="onClickFinish" primary solid :clickable="!isFinishClick" :disabled="!isSipNumberCountValid"/>
        </template>
    </ur-modal>
</template>
<script>
import urValidator from '@uidev/mixins/urValidator/urValidator.js';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import CMP_AIS_00005_C01 from './CMP_AIS_00005_C01';
import CMP_AIS_00005_C02 from './CMP_AIS_00005_C02';
import CMP_AIS_00005_C03 from './CMP_AIS_00005_C03';
import CMP_AIS_00005_C04 from './CMP_AIS_00005_C04';

export default  {
    name:'ServiceRequestNewModal',
    components:{
        urDataGrid,
    },
    props:{
        pageId: {type: String, required: true,},
    },
    data(){
        return {
            headers:[
                {text:'전화번호', value:'sipNumber', sort:true,
                    component:CMP_AIS_00005_C01,
                    customClass : function(v, r) {
                        if(r.oldStatusCode === 'B' || r.oldStatusCode === 'C' || r.oldStatusCode === 'E' || r.isChannelChange === true) {
                            return 'ur-data-grid-disabled';
                        }
                    }
                },
                {text:'채널', value:'channels', sort:true, 
                    component:CMP_AIS_00005_C02,
                    customClass : function(v, r) {
                        if(r.oldStatusCode === 'B' || r.oldStatusCode === 'C' || r.oldStatusCode === 'E' || r.isChannelChange === true) {
                            return 'ur-data-grid-disabled';
                        }
                    }
                },
                {text:'캠페인사용', value:'scheduleStatus', component:CMP_AIS_00005_C03,
                    customClass : function(v, r) {
                        if(r.oldStatusCode === 'B' || r.oldStatusCode === 'C' || r.oldStatusCode === 'E' || r.isChannelChange === true) {
                            return 'ur-data-grid-disabled';
                        }
                    }
                },
                {text:' ', value:'', component:CMP_AIS_00005_C04,
                    customClass : function(v, r) {
                        if(r.oldStatusCode === 'B' || r.oldStatusCode === 'C' || r.oldStatusCode === 'E' || r.isChannelChange === true) {
                            return 'ur-data-grid-disabled';
                        }
                    }
                }
            ],
            items:[],
            sipNumberPool:[],
            selectedSipNumberList:[],
            oldSipNumberCount:0,
            oldChannelsCount:0,
            sipNumberCount:0,
            channelsCount:0,
            isRowAddClick:false,
            isFinishClick:false,
            isInit:false,
        }
    },
    created(){},
    mounted(){},
    computed:{
        pClass(){
            let clazz = [];
            if(this.isInit === true && this.isSipNumberCountValid !== true) {
                clazz.push('error');
            }
            return clazz;
        },
        options(){
            let options = {
                noInfo:true,
                infinityScroll:true,
                height:270,
                headerHeight:48,
                rowHeight:49,
                msgEmptyData:' ',
                selectCheckOnly:true,
            }
            return options;
        },
        sipNumberList(){
            return(row) => {
                const currentSipNumber = row.sipNumber;
                var result = [];
                for(let index in this.sipNumberPool) {
                    var tempItem = this.sipNumberPool[index];
                    if(this.selectedSipNumberList.indexOf(tempItem.value) < 0 || tempItem.value == currentSipNumber) {
                        result.push(tempItem);
                    }
                }
                return result;
            };
        },
        newSipNumberCount(){
            return this.sipNumberCount;
        },
        newChannelsCount(){
            return this.channelsCount;
        },
        isRowAddDisabled(){
            let result = false;
            let data;
            //if(this.$refs['grid'] && this.$refs['grid'] != null && this.$refs['grid'].getDataSet() && this.$refs['grid'].getDataSet != null) {
            if(!!this.$refs['grid'] && !!this.$refs['grid'].getDataSet()) {
                data = this.$refs['grid'].getDataSet().getRawData();
            }
           if(data && data.length >= 100) {
               result = true;
           }
            return result;
        },
        isSipNumberCountValid() {
            return this.newSipNumberCount > 0 && this.newChannelsCount > 3;
        },

    },
    methods:{
        open(){
            this.init();
            this.getSipNumberList('listCCInUse')
            this.getSipNumberList('listSRInUse');
            this.getSipNumberList('listUseable');
            this.$refs['modal'].open();
        },
        close(){
            this.$refs['modal'].close();
            this.$refs['grid'].getDataSet().clearData();
            this.isFinishClick = false;
            this.isInit = false;
        },
        init(){
            this.items = [];
            this.oldSipNumberCount = 0;
            this.oldChannelsCount = 0;
            this.selectedSipNumberList = [];
            this.sipNumberPool = [];
            this.isFinishClick = false;
        },
        getSipNumberList(type){
            http.request(this.pageId, 'DTS_AIS_00003', {
                path:{
                    'type':type,
                }
            })
            .then(res => {
                if(type === 'listCCInUse') {
                    const sipNumberList = res.data.sipNumberList;
                    this.oldSipNumberCount = 0;
                    this.oldChannelsCount = 0;
                    for(let index in sipNumberList) {
                        let sipNumber = sipNumberList[index];
                        this.oldSipNumberCount++;
                        this.oldChannelsCount += sipNumber.channels;
                    }
                }
                else if(type === 'listSRInUse') {
                    this.items = [];
                    //this.oldSipNumberCount = 0;
                    //this.oldChannelsCount = 0;
                    for(let index in res.data.sipNumberList) {
                        let temp = res.data.sipNumberList[index];
                        //temp.oldChannels = temp.channels;
                        /*
                        if(temp.statusCode === 'E' || temp.statusCode === 'C' || temp.statusCode === 'D') {
                            this.oldSipNumberCount++;
                            this.oldChannelsCount += temp.oldChannels;
                        }
                        */
                        this.$nextTick(()=> {
                            let dataSet = this.$refs['grid'].getDataSet();
                            dataSet.addRow([]);
                            let length = dataSet.getRawData().length - 1;
                            //console.log('temp', temp);
                            if(length > -1) {
                                let lastItem = dataSet.getRawData()[length];
                                dataSet.setRowValue(lastItem, 'sipNumber', temp.sipNumber);
                                dataSet.setRowValue(lastItem, 'channels', temp.channels);
                                dataSet.setRowValue(lastItem, 'oldChannels', temp.channels);
                                dataSet.setRowValue(lastItem, 'scheduleStatus', temp.scheduleStatus);
                                dataSet.setRowValue(lastItem, 'statusCode', temp.statusCode);
                                dataSet.setRowValue(lastItem, 'oldStatusCode', temp.statusCode);
                                dataSet.setRowValue(lastItem, 'isNewNumber', false);
                                dataSet.setRowValue(lastItem, 'isChannelChange', temp.channelChange);
                            }
                            this.isInit = true;
                        });
                        this.options.msgEmptyData = '현재 사용중인 번호가 없습니다.';
                    }
                    //this.sipNumberCount = this.oldSipNumberCount;
                    //this.channelsCount = this.oldChannelsCount;
                } else if(type === 'listUseable') {
                    this.sipNumberPool = [];
                    for(let index in res.data.sipNumberList) {
                        let value = res.data.sipNumberList[index].sipNumber;
                        let temp = {
                            text:aiccUtils.phoneNumberFormat.format(value),
                            value:value,
                        };
                        this.sipNumberPool.push(temp);
                    }
                }
            });
        },
        postNewServiceRequest(){
            let param = [];
            //if(this.$refs['grid'] && this.$refs['grid'] != null && this.$refs['grid'].getDataSet() && this.$refs['grid'].getDataSet() != null) {
            if(!!this.$refs['grid'] && !!this.$refs['grid'].getDataSet()) {
                let data = this.$refs['grid'].getDataSet().getRawData();
                for(let index in data) {
                    const currItem = data[index];
                    if(currItem.sipNumber && currItem.sipNumber != '')  {
                        if(currItem.isNewNumber && currItem.isNewNumber === true) {
                            param.push({
                                sipNumber:currItem.sipNumber,
                                statusCode:'B',
                                channels:currItem.channels,
                            });
                        } else {
                            if(currItem.oldStatusCode && currItem.oldStatusCode === 'D') {
                                if(currItem.statusCode === 'E') {
                                    param.push({
                                        sipNumber:currItem.sipNumber,
                                        statusCode:'E',
                                        channels:currItem.oldChannels,
                                    });
                                } else if(currItem.channels != currItem.oldChannels) {
                                    param.push({
                                        sipNumber:currItem.sipNumber,
                                        statusCode:'C',
                                        channels:currItem.channels,
                                    });
                                }
                            }
                        }
                    }
                }
                if(param.length > 0) {
                    http.request(this.pageId, 'DTS_AIS_00004', {
                        data : {
                            srType:'B',
                            sipNumberList:param,
                        }
                    }).then(res => {
                        if(res.data.reply.code === '0000') {
                            this.close();
                        } else {
                            if(res.data.reply.korMsg && res.data.reply.korMsg != '') {
                                utils.aiccMessageBox('확인', res.data.reply.korMsg, '확인', null, null, null);
                            }
                            this.$nextTick(()=>{
                                this.isFinishClick = false;
                            });
                        }
                    }).catch(error => {
                        this.$nextTick(()=>{
                            this.isFinishClick = false;
                        });
                    });
                } else {
                    this.close();
                }
            }
            
        },
        onClickRowAdd(){
            let dataSet = this.$refs['grid'].getDataSet();
            dataSet.addRow([]);
            let length = dataSet.getRawData().length - 1;
            if(length > -1) {
                let lastItem = dataSet.getRawData()[length];
                dataSet.setRowValue(lastItem, 'sipNumber', null);
                dataSet.setRowValue(lastItem, 'channels', 1);
                dataSet.setRowValue(lastItem, 'statusCode', 'B');
                dataSet.setRowValue(lastItem, 'isNewNumber', true);
            }
            this.isRowAddClick = true;
            this.syncCount();
        },
        onClickRowDel(rowIdx){
            if(this.$refs['grid']) {
                if(this.$refs['grid'].getDataSet()) {
                    let row = this.$refs['grid'].getDataSet().getRawData()[rowIdx];
                    if(row) {
                        this.$refs['grid'].getDataSet().removeRow(row, null);
                        let index = this.selectedSipNumberList.indexOf(row.sipNumber);
                        //console.log('onClickRowDel selectedSipNumberIndex', index);
                        if(index > -1) {
                            this.selectedSipNumberList.splice(index, 1);
                        }
                    //} else {
                        //console.log('onClickRowDel', 'No Row');
                    }
                //} else {
                    //console.log('onClickRowDel', 'No DataSet');
                }
            //} else {
                //console.log('onClickRowDel', 'No Grid');
            }
            /*
            if(this.$refs['grid']) {
                if(this.$refs['grid'].$children) {
                    for(let index in this.$refs['grid'].$children) {
                        const children = this.$refs['grid'].$children[index];
                        console.log('onClickRowDel Children', children);
                        console.log('onClickRowDel Children Options Name', children.$options.name);
                        if(children.$options.name === 'urDataGridInfo') {
                            if(this.$refs['grid'].getDataSet()) {
                                let row = this.$refs['grid'].getDataSet().getRawData()[rowIdx];
                                if(row) {
                                    this.$refs['grid'].getDataSet().removeRow(row, null);
                                    let index = this.selectedSipNumberList.indexOf(row.sipNumber);
                                    console.log('onClickRowDel selectedSipNumberIndex', index);
                                    if(index > -1) {
                                        this.selectedSipNumberList.splice(index, 1);
                                    }
                                } else {
                                    console.log('onClickRowDel', 'No Row');
                                }
                            } else {
                                console.log('onClickRowDel', 'No DataSet');                
                            }
                        } 
                    }
                } else {
                    console.log('onClickRowDel', 'No Grid Children');
                }
            } else {
                console.log('onClickRowDel', 'No Grid');
            }
            */

            /*
           if(this.$refs['grid'].$children) {
               for(let index in this.$refs['grid'].$children) {
                   let children = this.$refs['grid'].$children[index];
                   if(children._name === '<UrDataGridInfo>') {
                        let row = this.$refs['grid'].getDataSet().getRawData()[rowIdx];
                        this.$refs['grid'].getDataSet().removeRow(row, null);
                        let index = this.selectedSipNumberList.indexOf(row.sipNumber);
                        if(index > -1) {
                            this.selectedSipNumberList.splice(index, 1);
                        }
                   }
               }
           }
           */
           this.syncCount();
        },
        onClickFire(rowIdx, statusCode){
            //console.log('onClickFire 1', rowIdx + ' / ' + statusCode);
            let row = this.$refs['grid'].getDataSet().getRawData()[rowIdx];
            //console.log('onClickFire 2', row);
            row.channels = row.oldChannels;
            row.statusCode = statusCode;
            this.$refs['grid'].getDataSet().setRowValue(row, 'channels', row.oldChannels);
            this.syncCount();
        },
        onDropdownSelected(rowIdx, sipNumber){
            let row = this.$refs['grid'].getDataSet().getRawData()[rowIdx];
            row.oldSipNumber = row.sipNumber;
            row.sipNumber = sipNumber;
            if(this.selectedSipNumberList.indexOf(row.sipNumber) < 0) {
                this.selectedSipNumberList.push(row.sipNumber);
            }
            if(row.oldSipNumber && row.sipNumber != row.oldSipNumber) {
                const deleteIndex = this.selectedSipNumberList.indexOf(row.oldSipNumber);
                if(deleteIndex > -1) {
                    this.selectedSipNumberList.splice(deleteIndex, 1);
                }
                row.oldSipNumber = row.sipNumber;
            }
            this.syncCount();
        },
        onStepperChange(rowIdx, channels){
            if(!!this.$refs['grid'] && !!this.$refs['grid'].getDataSet().getRawData()) {
                let data = this.$refs['grid'].getDataSet().getRawData();
                let item = data[rowIdx];
                item.channels = channels;
                this.$refs['grid'].getDataSet().setRowValue(item, 'channels', channels);
            }
            this.syncCount();
        },
        onClickFinish(){
            if(this.isFinishClick === false) {
                this.$nextTick(()=>{
                    this.isFinishClick = true;
                });
                let valid = urValidator.validateChildren(this.$refs['grid']);
                if(valid === true && this.isSipNumberCountValid === true) {
                    /*
                    if(this.newSipNumberCount < 1 || this.newSipNumberCount > 100 || this.newChannelsCount < 4 || this.newChannelsCount > 100) {
                        utils.aiccMessageBox('확인', '최소 전화번호 1개, 채널 4개(번호 당 1개 채널 필수) / 최대 전화번호 100개, 채널 100개 사용 가능합니다.', '확인', null, null, null);
                        this.$nextTick(()=>{
                            this.isFinishClick = false;
                        });
                        return;
                    }
                    */
                    this.postNewServiceRequest();
                } else {
                    this.$nextTick(()=>{
                        this.isFinishClick = false;
                    });
                }
            }
        },
        onDataChanged(e){
                this.$nextTick(()=>{
                    if(this.isRowAddClick === true) {
                        this.$refs['grid'].setScrollRow(this.items.length);
                        this.isRowAddClick = false;
                    }
                    this.syncCount();
                });
        },
        syncCount(){
            this.$nextTick(()=> {
                this.channelsCount = 0;
                this.sipNumberCount = 0;
                let data = this.$refs['grid'].getDataSet().getRawData();
                for(let index in data) {
                    const currItem = data[index];
                    // 해지신청을 누른 상태 혹은 기존의 해지신청건이 진행중인 경우(Statue Code : E) 를 합산에서 제외하기 위함
                    if(!(currItem.statusCode === 'E' || currItem.oldStatusCode === 'E')) {
                        this.sipNumberCount++;
                        if(isNaN(parseInt(currItem.channels)) === false) {
                            this.channelsCount += parseInt(currItem.channels);
                        }
                    }
                    /*
                    this.sipNumberCount++;
                    if(currItem.statusCode === 'E' && currItem.oldStatusCode != 'E') {
                        if(isNaN(parseInt(currItem.oldChannels)) === false) {
                            this.channelsCount += parseInt(currItem.oldChannels);
                        }
                    } else {
                        if(isNaN(parseInt(currItem.channels)) === false) {
                            this.channelsCount += parseInt(currItem.channels);
                        }
                    }
                    */
                }
            });
        },
        /*
        isChannelsValid(){
            let result = false;
            let data = this.$refs['grid'].getDataSet().getRawData();
            console.log(this.$refs['grid'].$children);
            for(let index in data) {
                const channels = data[index].channels;
                console.log(index, channels);
                if(channels === '' || isNaN(channels) === true) {
                    this.$refs['grid']
                }
            }
            return result;
        }
        */
    },
}
</script>
<style scoped>
    .tbl_list {
        width: 100%;
    }
    .tbl_list th {
        padding: 16px 0 16px 0;
        line-height: 24px;
        font-family: 'NotoSansCJKkr';
        font-size: 16px;
        font-weight: 500;
        vertical-align: top;
        text-align: left;
    }
    .tbl_list td {
        padding: 16px 0;
        font-family: 'NotoSansCJKkr';
    }
    .tbl_info {
        margin-bottom: 8px;
    }
    .box_common {
        line-height: 20px;
        padding: 14px 16px 13px;
        border-radius: 4px;
        background-color: #EFF1F8;
    }
    .box_common dt {
        font-weight: 500;
        color: #2f2f38;
    }
    .box_common dd {
        color: #959595;
        margin-left: 20px;
    }
    .box_common .change{
        padding-left: 31px;
        margin-left: 20px;
        display: inline-block;
        background: url('../../../../assets/images/aicc/ic_triangle.png') no-repeat 0 50%;
        
        background-size: 11px 12px;
    }
    .hbox {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .txt_desc {
        line-height: 1.5;
    }
    .mt0 {
        margin-top: 0 !important;
    }
    .ur-data-grid {
        min-width:0px;
        width:100%;
    }
    .ur-button--small {
        height: 24px;
    }
    .btn {
        display: inline-block;
        text-align: center;
        white-space: nowrap;
    }
    .btn_border {
        border: 1px solid #8B9ABC;
    }
    .btn_border:hover {
        background-color: #F7F7F7;
    }
    .btn_s {
        border-radius: 2px;
        min-width: 48px;
        height: 24px;
        line-height: 22px;
        padding: 0 8px;
        font-size: 12px;
        font-weight: 400;
    }
    .error {
        color:#FF5858;
    }
    ::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__content {
        height: calc(100% - 48px);
    }
    ::v-deep .ur-counter.ur-input.ur-data-grid__content__cell__value.ur-counter--medium.ur-counter--center > .ur-counter__input {
        height: 100%;
    }
    ::v-deep .ur-counter.ur-input.ur-data-grid__content__cell__value.ur-counter--medium.ur-counter--center.ur-counter--disabled > .ur-counter__input {
        height: 100%;
        background: #f7f7f7;
    }
    ::v-deep .ur-counter.ur-input.ur-data-grid__content__cell__value.ur-counter--medium.ur-counter--center {
        padding: 0px;
        background: #FFFFFF;
    }
    ::v-deep .ur-counter.ur-input.ur-data-grid__content__cell__value.ur-counter--medium.ur-counter--center.ur-counter--disabled {
        background: #f7f7f7;
    }
</style>
<!--
<style>

    .ur-data-grid__content__cell.ur-data-grid-disabled.ur-data-grid__content__cell--default .ur-counter.ur-input.ur-data-grid__content__cell__value.ur-counter--medium.ur-counter--center.ur-counter--disabled {
        background: #D0D3DE;
    }
    .ur-counter.ur-input .ur-data-grid__content__cell__value.ur-counter--medium.ur-counter--center .ur-counter--disabled input {
        height:100%
    }
</style>
-->